import { db } from './firebase';

export const doCreateUser = (user) => {
    console.log("start creating user")
    const creationDate = Math.round((new Date()).getTime() / 1000);
    const id = user.id;
    const accountType = user.accountType;
    const firstName = user.firstName;
    const lastName = user.lastName;
    const displayName = user.displayName;
    const email = user.email;
    const profilePicUrl= user.profilePicUrl ? user.profilePicUrl : null;
    return db.ref(`users/${id}`).set({
        accountType,
        firstName,
        lastName,
        displayName,
        email,
        profilePicUrl,
        creationDate
    });

}

export const updateProfilePicUrl = (id, url) =>{
    console.log("updating profile pic url")
    return db.ref(`users/${id}/profilePicUrl`).set(url);
}

export const getResourceCategory = (categoryName) =>{
    if(categoryName){
        return db.ref(categoryName).once('value');
    }
}




export const onceGetUsers = () =>
    db.ref('users').once('value');

export const getUser = (id) => {
    return db.ref(`users/${id}`).once('value')
}



// WEBPACK FOOTER //
// ./src/firebase/db.js